export default __webpack_public_path__ + "static/media/twiiterDeskFill.45867de0.svg";